import { FC, ReactNode, useId, useLayoutEffect } from 'react';
import { useDropdownGroupContext } from './DropdownGroupContext';

export interface IDropdownGroupLabelProps {
  children: ReactNode;
  className?: string;
}

/**
 * An accessible label that is automatically associated with its parent DropdownGroup.
 * Registers its ID with the parent group for aria-labelledby support.
 */
const DropdownGroupLabel: FC<IDropdownGroupLabelProps> = ({
  children,
  className = 'px-3 py-2 supporting-body text-gray-500',
}) => {
  const id = useId();
  const groupContext = useDropdownGroupContext();

  useLayoutEffect(() => {
    groupContext?.setLabelId(id);
    return () => {
      groupContext?.setLabelId(undefined);
    };
  }, [id, groupContext]);

  return (
    <p id={id} className={className}>
      {children}
    </p>
  );
};

export default DropdownGroupLabel;
